import React from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalBody, ModalFooter } from 'reactstrap';
import Translate from '../Translate';

const LogOutAlertModal = (props) => {
  const { isOpen, onClose, message, logoutToggle } = props;

  const [messageCode, variables] = message;

  const handleClose = async () => {
    onClose();
  };

  const validateLogout = async () => {
    await logoutToggle();
  };

  return (
    <Modal isOpen={isOpen} centered>
      <ModalBody className="pb-0">
        <div className="p-3">
          <div className="form-group justify-content-center text-Alert" data-cy="textAlertLogout">
            <Translate code={messageCode} {...variables} />
          </div>
        </div>
      </ModalBody>
      <ModalFooter className="justify-content-center">
        <button type="button" className="btn btn-3" onClick={handleClose}>
          <Translate code="cancel" />
        </button>
        <button type="button" className="btn btn-1" data-cy="logoutBtn" onClick={() => validateLogout()}>
          <Translate code="logout" />
        </button>
      </ModalFooter>
    </Modal>
  );
};

export default LogOutAlertModal;

LogOutAlertModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  message: PropTypes.oneOfType([PropTypes.array, PropTypes.string]).isRequired,
  logoutToggle: PropTypes.func.isRequired,
};
